/* eslint-disable */
export default {
  participants: 'Participantes',
  host: '(Anfitrião)',
  removeParticipant: 'Remover participante',
  removeTitle: 'Remover participante',
  removeDescription: 'Remover {name} desta conferência?',
  confirmButtonText: 'Remover',
  cancelButtonText: 'Cancelar',
} as const;

// @key: @#@"participants"@#@ @source: @#@"Participants"@#@
// @key: @#@"host"@#@ @source: @#@"(Host)"@#@
// @key: @#@"removeParticipant"@#@ @source: @#@"Remove participant"@#@
// @key: @#@"removeTitle"@#@ @source: @#@"Remove participant"@#@
// @key: @#@"removeDescription"@#@ @source: @#@"Remove {name} from this conference?"@#@
// @key: @#@"confirmButtonText"@#@ @source: @#@"Remove"@#@
// @key: @#@"cancelButtonText"@#@ @source: @#@"Cancel"@#@
